import styled from 'styled-components';

const PageDescription = styled.h5`
  width: 60%;
  line-height: 1.6em;
  font-weight: normal;
  opacity: 80%;
  @media (max-width: 500px) {
    width: 100%;
  }
`;
export default PageDescription;
